import React, { useState } from 'react';
import { IoCloseSharp } from "react-icons/io5";
import { motion } from 'framer-motion';

import ButtonWhite from '../../button/ButtonWhite';
import ButtonBack from '../../button/ButtonBack';
import ModalAlert from '../../modal/ModalAlert'

import { FormatMontoPSE } from '../../../utils/Utils'
import { ReactComponent as Left } from '../../../assets/IconsColurs/IconsGeneral/chevronLeft.svg'
import { IoIosArrowRoundDown } from "react-icons/io";
import { QRCodeCanvas } from "qrcode.react";

import COP from '../../../assets/currency/copu.png'
import USD from '../../../assets/currency/usd.png'
import QRCode from 'react-qr-code';
import ColorsMain from "../../../colors/ColorsMain";


const Create2FA = ({
    setModal2FA,
    backOTP,
    loadingOTP,
    Modal2FA,
    QRValue,
    setisOTP,
    OTPCreate,
    otp,
    handleChange,
    handleKeyDown,
    handlePaste,
    isOTP,
    errorOTP,
    onCloseFinal
}) => {

    const [loading, setLoading] = useState(false)

    const OnClose = () => {
        setisOTP(false)
        setModal2FA(false)
    };

    const modalVariants = {
        hidden: { scale: 0, opacity: 0 },
        visible: { scale: 1, opacity: 1, transition: { duration: 0.5, ease: "easeOut" } },
        exit: { scale: 0.8, opacity: 0, transition: { duration: 0.5, ease: "easeInOut" } },
    };



    console.log(" setOTPCreate(true)", OTPCreate);

    return (
        <>

            {Modal2FA && <>

                <div className="fixed inset-0 flex items-center justify-center bg-[#0e0e10] bg-opacity-85 z-50">
                    <motion.div
                        className="bg-[#26262D] rounded-lg shadow-lg w-[90%] max-w-2xl h-auto flex flex-col justify-between overflow-hidden"
                        variants={modalVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >

                        <div className="p-6">
                            <div className="w-full flex flex-row justify-between">
                                <p className="text-lg font-semibold text-white">
                                    {'Habilita tu autenticación 2FA'}
                                </p>
                                <IoCloseSharp
                                    size={25}
                                    color={"#b7b7b9"}
                                    onClick={onCloseFinal}
                                    className="cursor-pointer"
                                />
                            </div>
                            <div className="h-[1.5px] w-full bg-[#16161d] mt-4"></div>
                        </div>

                        {/* Contenido dinámico del modal */}
                        <div className="flex-grow px-6">

                            <motion.div
                                className="bg-[#26262D] "
                                key="step2"
                                variants={modalVariants}
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                                transition={{ duration: 0.5, ease: "easeOut" }}
                            >
                                {!isOTP && <div className='w-full h-[45vh]  mb-4 rounded-[12px] gap-2 flex items-center  flex-col justify-around' >
                                    <p className='text-left text-[#8A8A8E] mb-4'>Escanea este código QR con tu aplicación de autenticación (como Google Authenticator o Authy) para activar la verificación en dos pasos. Luego, introduce el código generado en la app para completar la configuración.</p>
                                    <div className='relative w-[200px] h-[200px] flex justify-center items-center'>
                                        {/* Esquinas en forma de L */}
                                        <div className="absolute top-0 left-0 w-6 h-6 border-t-4 border-l-4  border-white"></div>
                                        <div className="absolute top-0 right-0 w-6 h-6 border-t-4 border-r-4   border-white"></div>
                                        <div className="absolute bottom-0 left-0 w-6 h-6 border-b-4 border-l-4  border-white"></div>
                                        <div className="absolute bottom-0 right-0 w-6 h-6 border-b-4 border-r-4  border-white"></div>

                                        {/* QR Code */}
                                        <div style={{ position: "relative", display: "inline-block" }}>
                                            <QRCodeCanvas
                                                value={QRValue}
                                                size={180} // Tamaño del QR
                                                bgColor="transparent" // Color de fondo
                                                fgColor="#ffffff" // Color del QR
                                                level="H" // Nivel de corrección de errores
                                            />

                                        </div>

                                    </div>
                                    <ButtonWhite
                                        isDisabled={""}
                                        loading={""}
                                        onClick={() => setisOTP(true)}
                                        label={"Ya escaneé el código"}
                                    />
                                </div>}

                                <div className='w-full   mb-4 rounded-[12px] gap-2 flex items-center  flex-col justify-between ' >

                                    {isOTP && !OTPCreate && <p className=' text-xl mb-4'>Ingresa el código OTP generado</p>}
                                    <div>
                                        {isOTP && !loadingOTP && !OTPCreate && otp.map((digit, index) => (
                                            <input
                                                key={index}
                                                id={`otp-input-${index}`} // ID para cada input
                                                type="text"
                                                value={digit}
                                                onChange={(e) => handleChange(e.target.value, index)}
                                                onKeyDown={(e) => handleKeyDown(e, index)} // Manejo de tecla
                                                onPaste={handlePaste} // Manejo de pegado
                                                style={{
                                                    ...styles.input, // Estilos base
                                                    border: `1px solid ${ColorsMain.borderGray}`, // Borde por defecto con el color borderGray
                                                }}
                                                onBlur={(e) =>
                                                    (e.target.style.border = `1px solid ${ColorsMain.borderGray}`)
                                                } // Mantener el borde gris cuando no está en foco
                                                onFocus={(e) =>
                                                    (e.target.style.border = `1px solid ${ColorsMain.graywhite}`)
                                                } // Cambiar el borde cuando está en foco
                                                maxLength={1} // Solo permite un dígito
                                            />
                                        ))}

                                        {loadingOTP && isOTP && <div className="spinner-border animate-spin w-1 h-1 border-1 border-gray-300 border-t-transparent rounded-full"></div>}

                                        <p className='text-[#e4847f] text-center mt-4'>{errorOTP}</p>


                                        {OTPCreate &&
                                            <div className='flex items-center flex-col'>
                                                <p className='text-xl text-center'>¡Código OTP verificado con éxito! Tu autenticación ha sido completada. </p>
                                                <ButtonWhite
                                                    isDisabled={""}
                                                    loading={""}
                                                    onClick={() => onCloseFinal()}
                                                    label={"Listo"}
                                                />
                                            </div>
                                        }
                                    </div>


                                    {!loadingOTP && !OTPCreate && isOTP && <ButtonBack label={'Volver al QR'} paddingY={2} marginTop={0} onClick={() => backOTP()} />}


                                </div>

                            </motion.div>

                        </div>


                    </motion.div>
                </div >



            </>}
        </>
    );
};
const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Fondo oscuro semi-transparente
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
    },
    modal: {
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        maxWidth: "400px",
        width: "100%",
        textAlign: "center",
        position: "relative",
    },
    closeButton: {
        position: "absolute",
        top: "10px",
        right: "10px",
        background: "transparent",
        border: "none",
        fontSize: "18px",
        cursor: "pointer",
    },
    qrContainer: {
        display: "flex",
        marginTop: 20,
        alignItems: "center",
    },
    input: {
        width: "62px",
        height: "64px",
        fontSize: 32,
        marginRight: "16px",
        textAlign: "center",
        borderRadius: "5px",
        color: ColorsMain.texttMain,

        background: ColorsMain.bgMain,
    },
};
export default Create2FA;

